module.exports = __webpack_public_path__ + "static/media/cert_part1.0601acf3.png";